import Vue from "vue";
// svg组件
import SvgIcon from "@/components/globalComponents/SvgIcon"; // svg component

// register globally
Vue.component("svg-icon", SvgIcon);
// 自动引入 @/src/icons
const requireAll = (requireContext) => {
  requireContext.keys().map(requireContext);
};
// 引入根目录下的svg文件
const req = require.context("./svg", false, /\.svg$/);
requireAll(req);
// 引入 novaIcon 子目录下的svg文件
const reqNovaIcon = require.context("./svg/novaIcon", false, /\.svg$/);
requireAll(reqNovaIcon);
